import { Button } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import EditIcon from '@mui/icons-material/Edit';

import QueryDialog from "components/queries/QueryDialog";
import { defaultQuery, Query } from 'system/query/Query';
import APIRequest from "system/APIRequest";

interface NewQueryButtonProps {
  fixedDatasetId?: string;
  hideQueryTitle?: boolean;
  onChange: (query: Query) => void;
  query?: Query | null;
}

export default function NewQueryButton(props: NewQueryButtonProps): React.JSX.Element {
  const { i18n } = useTranslation();

  const [open, setOpen] = useState<boolean>(false);

  const starterQuery = new Query(defaultQuery);

  async function handleNewQueryChange(queryId: string) {
    const response = await APIRequest(`obj/query/${queryId}`)
    const newQuery = new Query(response.output);
    props.onChange(newQuery);
    setOpen(false);
  }

  return (
    <>
      <Button
        endIcon={<EditIcon />}
        onClick={() => setOpen(true)}
        size="small"
        sx={{ ml: 1 }}
        variant={props.query ? "outlined" : "contained"} >
        {props.query ? i18n.t('query-form.edit-query') : i18n.t('query-form.create-query')}
      </Button>
      {open &&
        <QueryDialog
          fixedDatasetId={props.fixedDatasetId}
          hideQueryTitle={props.hideQueryTitle}
          isOpen={open}
          onClose={() => setOpen(false)}
          onSubmit={handleNewQueryChange} 
          query={props.query || starterQuery}
        />
      }
    </>
  )
}